const locale = "fr-FR";

export default function (d) {
    if (d) {
        const date = new Date(d);
        const jour = date.toLocaleDateString(locale, { month: "2-digit", day: "2-digit", year: "numeric" });
        const hm = date.toLocaleTimeString(locale, { hour: "2-digit", minute: "2-digit" });
        return `${jour} ${hm}`;
    } else {
        return null;
    }
}
